import React from "react";
import { useTranslation } from "react-i18next";
import { Checkbox } from "@mui/material";
import CustomToggleButton from "../global/CustomToggleButton.component";
import CustomButtonLoader from "../global/CustomButtonLoader.component";
import { regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import MfaDialogBox from "../profile-form/MfaDialogBox.component";
import OtpInputField from "./OtpInputField.component";
import { apiErrorHandler } from "../../utils/errorHandler";
import { openSnackBar } from "../../redux/actions/snackbar.actions";
import { useDispatch, useSelector } from "react-redux";
import { getApiUrl } from "../../utils/apiUrls";
import axios from "axios";
import moment from "moment/moment";
import useWindowSize from "../../hooks/useWindowSize";
import CustomToolTip from "../custom-tooltip/CustomTooltip.component";
import { addPad, replaceDynamicString } from "../../utils/helperFn";

const staticDataForMfa = {
  type: "FIRST_STEP",
  otp: Array(6).fill(""),
  otpHasErrorMsg: "",
};
const resendOtpTime = 60; // TIME IN SECOND
const MfaForm = ({
  skipForNowHandler,
  mfadata,
  mfadataHandler,
  actionHandler,
}) => {
  const windowSize = useWindowSize();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const envState = useSelector((state) => state.env);
  const [enableTimeFlag, setEnableTimeFlag] = React.useState(false);
  const [secondsLeft, setSecondsLeft] = React.useState(resendOtpTime);
  const endTimeRef = React.useRef(null);
  const [textBoxStr, setTextBoxStr] = React.useState({ value: "", msg: null });
  const [formVal, setFormVal] = React.useState({
    id: null,
    isLoading: false,
    qrcode: null,
    manualCode: null,
  });
  const textBoxStrHandler = (val) => {
    setTextBoxStr(val);
  };
  const actionHandlerWraper = (e) => {
    e.preventDefault();
    actionHandler();
  };
  React.useLayoutEffect(() => {
    if (!enableTimeFlag && mfadata?.type === "SECOND_STEP_EMAIL") {
      endTimeRef.current = new Date().getTime() + resendOtpTime * 1000 - 100;
      const interval = setInterval(() => {
        const now = new Date().getTime();
        const timeRemaining = Math.max(
          0,
          Math.round((endTimeRef.current - now) / 1000)
        );
        if (timeRemaining <= 0) {
          setSecondsLeft(resendOtpTime);
          setEnableTimeFlag(true);
          clearInterval(interval);
        } else {
          setSecondsLeft(timeRemaining);
        }
      }, 1000);
      return () => clearInterval(interval);
    } else {
      setSecondsLeft(resendOtpTime);
    }
  }, [enableTimeFlag, mfadata?.type]);

  const renderAuthenticators = () => {
    if(envState?.AUTHENTICATORS) {
      const struct = [" "];
      envState.AUTHENTICATORS.forEach((authenticator, index, arr) => {

        if(index === (arr.length - 1)) {
          struct.push(" " + t("or") + " ");
        }

        struct.push(
          authenticator.enabled ? <a
            className="text-action-1 cm-pointer"
            href={authenticator.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t(authenticator.value)}
          </a> : <CustomToolTip
            title={replaceDynamicString(t("authenticator_method_unavailable_in_your_region"), [t(authenticator.value)])}
            disableTooltip={authenticator.enabled}
          >
            <span className="cm-action-disabled cm-default">{t(authenticator.value)}</span>
          </CustomToolTip>
        ) 

        if(index < (arr.length - 2)) {
          struct.push(", ");
        }
      });

      struct.push(" ")

      return struct;
    }

    return null;
  }

  if (mfadata?.type === "FIRST_TIME_LOGIN") {
    const verifyOtpHandler = async (passcode) => {
      try {
        if (formVal.isLoading) return;
        setFormVal({ ...formVal, isLoading: false });
        if (passcode.length !== 6) {
          throw Error("opt_should_have_six_number");
        }
        const resData = await axios.post(`${getApiUrl("verifyQrcode")}`, {
          candidateId: mfadata.candidateId,
          passCode: passcode,
        });
        mfadataHandler({
          modalOpenToggle: false,
          viaAuthenticator: true,
          qrIsSet: true,
        });
        dispatch(
          openSnackBar({
            msg: t("successfully_setup_of_app_by_qr"),
            type: "success",
          })
        );
        setFormVal({ ...formVal, isLoading: false });
      } catch (error) {
        setFormVal({ ...formVal, isLoading: false });
        const errObj = apiErrorHandler(error);

        dispatch(
          openSnackBar({
            msg: t(errObj.statusText),
            type: "error",
          })
        );
      }
    };
    const fetchDataForQrCode = async () => {
      try {
        const resData = await axios.post(getApiUrl("getqrcode"), {
          candidateId: Number(mfadata.candidateId),
        });
        setFormVal({
          qrcode: resData.data.data,
          id: resData.data.id,
          manualCode: resData.data.manualCode,
        });
        mfadataHandler({ modalOpenToggle: true });
      } catch (error) {
        const errObj = apiErrorHandler(error);
        dispatch(
          openSnackBar({
            msg: t(errObj.statusText),
            type: "error",
          })
        );
      }
    };
    return (
      <div>
        <div
          className="d-flex bg-blue-gray-50 py-12 border border-blue-gray-300 cm-btn-radius"
          style={{ paddingRight: "20px", paddingLeft: "20px" }}
        >
          <div className="flex-grow-1">
            <p className={`mb-0 cm-sm-txt text-blue-800 fw-medium`}>
              {t("via_email_id")}
            </p>
            <p className={`mb-0 text-blue-gray-700 cm-xs-txt fw-medium`}>
              {t("We_ll_send_a_code_to_your_email")}
            </p>
          </div>
          <CustomToggleButton
            onActive={mfadata.viaEmail}
            disabled={false}
            size={"s"}
            cssClass={"me-1"}
            onClickHandle={() => {
              mfadataHandler({ viaEmail: !mfadata.viaEmail });
            }}
          />
        </div>
        <div
          className="d-flex mt-3 bg-blue-gray-50 py-12 border border-blue-gray-300 text-blue-800 cm-btn-radius"
          style={{ paddingRight: "20px", paddingLeft: "20px" }}
        >
          <div className="flex-grow-1 ms-1">
            <p className={`mb-0 cm-sm-txt text-blue-800 fw-medium`}>
              {t("via_authenticator_app")}
            </p>
            <p className={`mb-0 text-blue-gray-700 cm-xs-txt fw-medium`}>
              {t("set_up_authenticator_app_generate_codes")}
            </p>
          </div>
          <CustomToggleButton
            onActive={mfadata.viaAuthenticator}
            disabled={false}
            cssClass={"me-1"}
            size={"s"}
            onClickHandle={() => {
              if (!mfadata.qrIsSet) {
                fetchDataForQrCode();
                return;
              }
              mfadataHandler({ viaAuthenticator: !mfadata.viaAuthenticator });
            }}
          />
        </div>
        <div className="cm-auth-hr bg-blue-gray-300" />
        <div className="d-flex">
          <CustomButtonLoader
            showLoadingState={false}
            disabled={false}
            icon={regular("angle-right")}
            buttonLabel={t(`${t("proceed")}`)}
            colorTheme={"hoverBlue2"}
            buttonStyle={"py-2 px-3 cm-mar-left-icon fw-medium"}
            handleOnClick={() => {
              if (mfadata.viaEmail || mfadata.viaAuthenticator) {
                actionHandler();
              } else {
                dispatch(
                  openSnackBar({
                    msg: t("both_mfa_options_cannot_be_disabled"),
                    type: "error",
                  })
                );
                return;
              }
            }}
          />
          {!moment().isAfter(
            mfadata.mfaDate * 1000
          ) &&
            !(mfadata.viaAuthenticator || mfadata.viaEmail) && (
              <CustomButtonLoader
                showLoadingState={false}
                disabled={false}
                icon={""}
                buttonLabel={t(`${t("skip_for_now")}`)}
                colorTheme={"plainWhite"}
                buttonStyle={"ms-12 py-2 px-3 fw-medium"}
                handleOnClick={() => skipForNowHandler()}
              />
            )}
        </div>
        {/* SETUP MFA MODAL */}
        {mfadata.modalOpenToggle && (
          <MfaDialogBox
            t={t}
            textBoxStr={textBoxStr}
            textBoxStrHandler={textBoxStrHandler}
            mfadataHandler={mfadataHandler}
            isOpen={true}
            data={formVal}
            onSaveHandler={verifyOtpHandler}
          />
        )}
      </div>
    );
  }
  if (mfadata?.type === "FIRST_STEP") {
    const csshander = (val) => {
      if (
        (val === "via_authenticator_app" && mfadata.viaAuthenticator) ||
        (val === "via_email_id" && mfadata.viaEmail)
      ) {
        return "border-action-blue text-blue-800 cm-bg-blue-light";
      } else if (
        mfadata.originalAuthenticationType !== "EMAIL_AND_AUTHENTICATION_APP"
      ) {
        return "border-blue-300 text-blue-gray-400";
      } else {
        return "border-blue-300 text-blue-800 cm-pointer";
      }
    };
    const isDisabledCheck = () => {
      if (!!mfadata.isBackButtonStr) {
        if (
          mfadata.originalAuthenticationType !== "EMAIL_AND_AUTHENTICATION_APP"
        ) {
          return true;
        }
        if (
          mfadata.backButtonHistory.defaultAuthenticationTypeFlag ===
          mfadata.defaultAuthenticationTypeFlag
        ) {
          if (mfadata.backButtonHistory.type === "EMAIL" && mfadata.viaEmail) {
            return true;
          }
          if (
            mfadata.backButtonHistory.type === "AUTHENTICATION_APP" &&
            mfadata.viaAuthenticator
          ) {
            return true;
          }
        }
      }
      return false;
    };
    return (
      <div>
        <CustomToolTip
          title={t("this_method_is_currently_disabled_account")}
          disableTooltip={
            mfadata.originalAuthenticationType !== "AUTHENTICATION_APP"
          }
        >
          <div
            className={`d-flex px-3 py-12 border fw-medium cm-btn-radius mb-3 ${csshander(
              "via_email_id"
            )}`}
            onClick={() => {
              if (mfadata.originalAuthenticationType === "AUTHENTICATION_APP")
                return;
              mfadataHandler({ viaEmail: true, viaAuthenticator: false });
            }}
          >
            <input
              type="radio"
              id="via_email_id"
              value={mfadata.viaEmail}
              checked={mfadata.viaEmail}
              disabled={
                mfadata.originalAuthenticationType === "AUTHENTICATION_APP"
              }
              className={`${
                mfadata.viaEmail
                  ? ""
                  : mfadata.originalAuthenticationType === "AUTHENTICATION_APP"
                  ? ""
                  : "cm-pointer"
              }`}
            />
            <label
              for="via_email_id"
              className={`cm-sm-txt text-center flex-grow-1 ${
                windowSize.isMobile ? "text-white" : ""
              } ${
                mfadata.viaEmail
                  ? ""
                  : mfadata.originalAuthenticationType === "AUTHENTICATION_APP"
                  ? ""
                  : "cm-pointer"
              }`}
            >
              {t("via_email_id")}
            </label>
          </div>
        </CustomToolTip>
        <CustomToolTip
          title={t("this_method_is_currently_disabled_account")}
          disableTooltip={mfadata.originalAuthenticationType !== "EMAIL"}
        >
          <div
            className={`d-flex cm-sm-txt px-3 py-12 border fw-medium cm-btn-radius ${csshander(
              "via_authenticator_app"
            )} `}
            onClick={() => {
              if (mfadata.originalAuthenticationType === "EMAIL") return;
              mfadataHandler({ viaEmail: false, viaAuthenticator: true });
            }}
          >
            <input
              type="radio"
              id="via_authenticator_app"
              value={mfadata.viaAuthenticator}
              checked={mfadata.viaAuthenticator}
              disabled={mfadata.originalAuthenticationType === "EMAIL"}
              className={`${
                mfadata.viaAuthenticator
                  ? ""
                  : mfadata.originalAuthenticationType === "EMAIL"
                  ? ""
                  : "cm-pointer"
              }`}
            />
            <label
              for="via_authenticator_app"
              className={`text-center flex-grow-1 ${
                windowSize.isMobile ? "text-white" : ""
              } ${
                mfadata.viaAuthenticator
                  ? ""
                  : mfadata.originalAuthenticationType === "EMAIL"
                  ? ""
                  : "cm-pointer"
              }`}
            >
              {t("via_authenticator_app")}
            </label>
          </div>
        </CustomToolTip>
        <div className="cm-auth-hr bg-blue-gray-300" />
        {(mfadata.viaEmail || mfadata.viaAuthenticator) && (
          <p
            className={`my-0 fw-medium cm-sm-txt ${
              windowSize.isMobile ? "text-white" : "text-blue-gray-700"
            }`}
          >
            {mfadata.viaEmail ? (
              t("you_will_receive_digit_verification_code")
            ) : (
              <>
                <p className="cm-sm-txt text-blue-gray-700 mb-0">

                  {t("download_install_any_authenticator_apps_like_auth")}
                  {renderAuthenticators()}
                  {t("to_generate_login_codes")}
                </p>
              </>
            )}
          </p>
        )}
        <div
          className={`d-flex mt-3 ${
            mfadata.originalAuthenticationType ===
              "EMAIL_AND_AUTHENTICATION_APP" &&
            (mfadata.viaEmail || mfadata.viaAuthenticator)
              ? ""
              : "cm-pointer-none"
          }`}
        >
          <Checkbox
            checked={mfadata.defaultAuthenticationTypeFlag}
            onChange={() => {
              if (
                mfadata.originalAuthenticationType ===
                  "EMAIL_AND_AUTHENTICATION_APP" &&
                (mfadata.viaEmail || mfadata.viaAuthenticator)
              )
                mfadataHandler({
                  defaultAuthenticationTypeFlag:
                    !mfadata.defaultAuthenticationTypeFlag,
                });
            }}
            inputProps={{ "aria-label": "controlled" }}
            id={"mfaAsDefault"}
            disableRipple={true}
            className="cm-checkbox-input my-auto"
            disabled={
              mfadata.originalAuthenticationType !==
                "EMAIL_AND_AUTHENTICATION_APP" &&
              (mfadata.viaEmail || mfadata.viaAuthenticator)
            }
          />
          <label
            for="mfaAsDefault"
            className={`my-0 pe-3 fw-medium cm-sm-txt my-auto ms-2 ${
              windowSize.isMobile ? "text-white" : ""
            } ${
              mfadata.originalAuthenticationType ===
                "EMAIL_AND_AUTHENTICATION_APP" &&
              (mfadata.viaEmail || mfadata.viaAuthenticator)
                ? "cm-pointer text-blue-gray-700"
                : "text-blue-gray-400"
            }`}
          >
            {t("set_the_above_selected_mfa_method")}
          </label>
        </div>
        <div className="d-flex">
          <CustomButtonLoader
            showLoadingState={false}
            disabled={isDisabledCheck()}
            icon={regular("angle-right")}
            buttonLabel={t(`${t("next")}`)}
            colorTheme={"hoverBlue2"}
            buttonStyle={"mt-32 py-2 px-32 cm-mar-left-icon fw-medium"}
            handleOnClick={() => {
              if (mfadata.viaAuthenticator || mfadata.viaEmail) {
                actionHandler();
              } else {
                dispatch(
                  openSnackBar({
                    msg: t("select_one_of_the_above_selection"),
                    type: "info",
                  })
                );
              }
            }}
          />
          {!!mfadata.isBackButtonStr && (
            <CustomButtonLoader
              showLoadingState={false}
              disabled={false}
              icon={null}
              buttonLabel={t(`${t("back")}`)}
              colorTheme={"white"}
              buttonStyle={"mt-32 py-2 px-32 ms-12 fw-medium"}
              handleOnClick={() => {
                mfadataHandler({
                  type: mfadata.isBackButtonStr,
                  isBackButtonStr: "",
                  backButtonHistory: {
                    type: "",
                    defaultAuthenticationTypeFlag: "",
                  },
                });
              }}
            />
          )}
        </div>
      </div>
    );
  }
  if (mfadata?.type === "SECOND_STEP_EMAIL") {
    return (
      <form onSubmit={actionHandlerWraper}>
        <p
          className={`fw-medium cm-sm-txt mb-4 mt-4 text-break ${
            windowSize.isMobile ? "text-white" : "text-blue-gray-700"
          }`}
        >
          {t("enter_verification_code_sent_email_id") + ` "`}
          <span
            className={`${
              windowSize.isMobile ? "text-white" : "text-blue-800"
            }`}
          >
            {mfadata.emailId}
          </span>
          "
        </p>
        <p
          className={`mb-12 cm-xs-txt  fw-medium ${
            windowSize.isMobile ? "text-white" : "text-blue-gray-700"
          }`}
        >
          {t("enter_digit_verification_code_generated")}
        </p>
        <OtpInputField
          t={t}
          otp={mfadata.otp}
          hasErrorMsg={mfadata.otpHasErrorMsg}
          mfadataHandler={mfadataHandler}
        />
        <div className="mb-0 mt-3 d-flex">
          <CustomToolTip
            title={t("resend_button_enabled_in_some_time_toolip")}
            disableTooltip={enableTimeFlag}
          >
            <p
              className={`fw-medium cm-sm-txt my-auto ${
                enableTimeFlag
                  ? "text-decoration-underline text-blue-500 cm-pointer"
                  : "text-blue-gray-500"
              }`}
              onClick={() => {
                if (!enableTimeFlag) return;
                setEnableTimeFlag(false);
                actionHandler("RESEND_OTP");
              }}
            >
              {t("resend_otp")}
            </p>
          </CustomToolTip>
          {!!secondsLeft && !enableTimeFlag && (
            <p className="my-auto fw-medium cm-sm-txt text-blue-500 ms-3 ps-3 border-start border-blue-gray-300">
              <span className="text-blue-gray-700">{t("time_remaining")}</span>
              {" 00:" + addPad(Math.ceil(secondsLeft)) + "s"}
            </p>
          )}
        </div>
        <hr className="cm-auth-hr bg-blue-gray-300" />
        <div className="d-flex">
          <CustomButtonLoader
            showLoadingState={false}
            disabled={false}
            icon={regular("angle-right")}
            buttonLabel={t(`${t("submit")}`)}
            colorTheme={"hoverBlue2"}
            buttonStyle={"py-2 px-3 cm-mar-left-icon fw-medium"}
            handleOnClick={() => {}}
          />
          <CustomButtonLoader
            showLoadingState={false}
            disabled={false}
            icon={""}
            buttonLabel={t(`${t("verify_via_another_method")}`)}
            colorTheme={"white"}
            textColor={"text-action-blue"}
            buttonStyle={"ms-12 py-2 px-3 fw-medium"}
            handleOnClick={() => {
              mfadataHandler({
                ...staticDataForMfa,
                isBackButtonStr: "SECOND_STEP_EMAIL",
                backButtonHistory: {
                  type: "EMAIL",
                  defaultAuthenticationTypeFlag:
                    mfadata.defaultAuthenticationTypeFlag,
                },
              });
            }}
          />
        </div>
      </form>
    );
  }
  if (mfadata?.type === "SECOND_STEP_APP") {
    return (
      <form onSubmit={actionHandlerWraper}>
        <p
          className={`my-0 fw-medium cm-sm-txt ${
            windowSize.isMobile ? "text-white" : "text-blue-gray-700"
          }`}
        >
          {t("please_enter_the_verification_code_authenticator")}
        </p>
        <p
          className={`my-0 fw-medium cm-sm-txt mb-12 mt-4 ${
            windowSize.isMobile ? "text-white" : "text-blue-gray-700"
          }`}
        >
          {t("enter_digit_verification_code_generated")}
        </p>
        <OtpInputField
          t={t}
          otp={mfadata.otp}
          hasErrorMsg={mfadata.otpHasErrorMsg}
          mfadataHandler={mfadataHandler}
        />
        <hr className="cm-auth-hr bg-blue-gray-300" />
        <div className="d-flex">
          <CustomButtonLoader
            showLoadingState={false}
            disabled={false}
            icon={regular("angle-right")}
            buttonLabel={t(`${t("submit")}`)}
            colorTheme={"hoverBlue2"}
            buttonStyle={"py-2 px-3 cm-mar-left-icon fw-medium"}
            handleOnClick={() => {}}
          />
          <CustomButtonLoader
            showLoadingState={false}
            disabled={false}
            icon={""}
            buttonLabel={t(`${t("verify_via_another_method")}`)}
            colorTheme={"white"}
            buttonStyle={"ms-12 py-2 px-3 fw-medium"}
            textColor={"text-action-blue"}
            handleOnClick={() => {
              mfadataHandler({
                ...staticDataForMfa,
                isBackButtonStr: "SECOND_STEP_APP",
                backButtonHistory: {
                  type: "AUTHENTICATION_APP",
                  defaultAuthenticationTypeFlag:
                    mfadata.defaultAuthenticationTypeFlag,
                },
              });
            }}
          />
        </div>
      </form>
    );
  }
};

export default MfaForm;
